var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "LegsFrieze__container" }, [
    _c(
      "div",
      {
        class: {
          LegsFrieze__wrapper: true,
          LegsFrieze__wrapperDesktopNotMulti:
            _vm.legs.length <= 3 && _vm.$mq == "desktop"
        },
        style: _vm.wrapperStyle
      },
      [
        _vm.isMultiLegs
          ? _c("div", {
              staticClass: "LegsFrieze__item",
              style: _vm.spacerStyle
            })
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.legs, function(leg, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "LegsFrieze__item",
              style: _vm.legStyle,
              attrs: { id: "item-" + index }
            },
            [
              _c("div", { staticClass: "LegsFrieze__lineMarker" }, [
                index === 0
                  ? _c("div", { staticClass: "LegsFrieze__EmptyLine" })
                  : _c("div", { staticClass: "LegsFrieze__line" }, [_c("hr")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "LegsFrieze__Marker preventClick" },
                  [
                    _c(
                      "BaseIcon",
                      {
                        class: { "fix-marker": _vm.littleMarker(index) },
                        attrs: { size: _vm.littleMarker(index) ? "sm" : "m" }
                      },
                      [
                        _vm._v(
                          "\n                        marker_new\n                    "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                index === _vm.legs.length - 1 && _vm.legs.length != 1
                  ? _c("div", { staticClass: "LegsFrieze__EmptyLine" })
                  : _c("div", { staticClass: "LegsFrieze__line" }, [
                      leg.time
                        ? _c("span", { staticClass: "LegsFrieze__time" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(leg.time) +
                                "\n                    "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("hr", { class: { withArrow: !_vm.badged } }),
                      _vm._v(" "),
                      _vm.badged
                        ? _c(
                            "span",
                            { staticClass: "LegsFrieze__badge AA__badge" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(index + 1) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
              ]),
              _vm._v(" "),
              leg && typeof leg === "string"
                ? _c("span", { staticClass: "LegsFrieze__label" }, [
                    _vm._v(
                      "\n                " + _vm._s(leg) + "\n            "
                    )
                  ])
                : _vm._e()
            ]
          )
        }),
        _vm._v(" "),
        _vm.isMultiLegs
          ? _c("div", {
              staticClass: "LegsFrieze__item",
              style: _vm.spacerStyle
            })
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.withDetails
      ? _c("div", { staticClass: "LegsFrieze__infos" }, [
          _c(
            "div",
            { staticClass: "LegsFrieze__info" },
            [
              _c("BaseIcon", { staticClass: "mr-1", attrs: { size: "m" } }, [
                _vm._v("passenger_grey")
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.nbPassengers))])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "LegsFrieze__info" },
            [
              _c("BaseIcon", { staticClass: "mr-1", attrs: { size: "m" } }, [
                _vm._v("calendar_grey")
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.flightDates.join(" - ")))])
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c4b6a0f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c4b6a0f","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/LegsFrieze.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5c4b6a0f","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/LegsFrieze.vue
// module chunks = 1 2 3